import request from '@/utils/request'


// 查询app首页底部tag图片列表
export function listVideo(query) {
  return request({
    url: '/video/appImg/list',
    method: 'get',
    params: query
  })
}

// 查询app首页底部tag图片分页
export function pageVideo(query) {
  return request({
    url: '/video/appImg/page',
    method: 'get',
    params: query
  })
}

// 查询app首页底部tag图片详细
export function getVideo(data) {
  return request({
    url: '/video/appImg/detail',
    method: 'get',
    params: data
  })
}

// 新增app首页底部tag图片
export function addVideo(data) {
  return request({
    url: '/video/appImg/add',
    method: 'post',
    data: data
  })
}

// 修改app首页底部tag图片
export function updateVideo(data) {
  return request({
    url: '/video/appImg/edit',
    method: 'post',
    data: data
  })
}

// 删除app首页底部tag图片
export function delVideo(data) {
  return request({
    url: '/video/appImg/delete',
    method: 'post',
    data: data
  })
}
